<template>
  <!--  <v-list-item two-line>-->
  <!--    <v-list-item-content>-->
  <!--      <v-btn-->
  <!--        v-if="office && office.id"-->
  <!--        text-->
  <!--        x-small-->
  <!--        color="primary"-->
  <!--        style="text-decoration: underline"-->
  <!--        @click="gotoOfficeData(office)"-->
  <!--      >-->
  <!--        {{ linkText || office.title }}-->
  <!--      </v-btn>-->
  <!--      <v-list-item-subtitle v-else>-->
  <!--        {{ 'Нет' }}-->
  <!--      </v-list-item-subtitle>-->
  <!--    </v-list-item-content>-->
  <!--  </v-list-item>-->
  <span
    v-if="office && office.id"
    style="text-decoration: underline;color: #1976d2 !important;cursor: pointer"
    class="btn"
    @click="gotoOfficeData(office)"
  >
    {{ linkText || office.title }}

  </span>
</template>

<script>

import { OFFICE_VIEW_ROUTE_NAME } from '@/router/client'

export default {
  name: 'OfficeListItemComponent',
  props: {
    office: {
      type: Object
    },
    linkText: {
      type: String
    },
  },
  async  created () {
  },
  methods: {
    gotoOfficeData (item) {
      const routeData = this.$router.resolve({ name: OFFICE_VIEW_ROUTE_NAME, params: { id: item.id } })
      window.open(routeData.href, '_blank')
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
